/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

const getUtmTags = () => {
  let utmSource;
  let utmMedium;
  let utmContent;
  let utmCampaign;
  let utmTerm;
  if (window.location.search.includes("utm")) {
    const param = new URLSearchParams(window.location.search);

    const getUtmValue = (utmTag) => {
      return param.get(utmTag) || "(none)";
    };

    utmSource = getUtmValue("utm_source");
    utmContent = getUtmValue("utm_content");
    utmCampaign = getUtmValue("utm_campaign");
    utmMedium = getUtmValue("utm_medium");
    utmTerm = getUtmValue("utm_term");
  } else {
    utmSource = "";
    utmContent = "";
    utmCampaign = "";
    utmMedium = "";
    utmTerm = "";
  }

  return {
    utmSource,
    utmMedium,
    utmContent,
    utmCampaign,
    utmTerm
  };
};

export default getUtmTags;
